export const DEVICES_ASSIGNED_COOKIE = 'DEVICES_ASSIGNED';
export const LOCAL_STORAGE_DEVICES = 'privateDeviceManagement';

export const DEVICE_STATES = Object.freeze({
  AVAILABLE: {
    color: 'green',
    text: 'Available',
  },
  IN_USE: {
    color: 'orange',
    text: 'In Use',
  },
  CLEANING: {
    color: 'red',
    text: 'Cleaning',
  },
  REBOOTING: {
    color: 'red',
    text: 'Rebooting',
  },
  MAINTENANCE: {
    color: 'red',
    text: 'Maintenance',
  },
  OFFLINE: {
    color: 'red',
    text: 'Offline',
  },
});

export const EDIT_DEVICE_SETTINGS_MODAL = 'editDeviceSettingsModal';

export const APP_ALLOWLIST_TOOLTIP = 'This setting allows specific applications to remain on the devices.';
export const APP_ALLOWLIST_INPUT_HELPER = 'Enter the package name (Android) or bundle ID (iOS) of the apps you want to allowlist.';
export const SYSTEM_APP_ALLOWLIST_TOOLTIP = 'This setting allows specific system applications to remain on the devices.';
export const SYSTEM_APP_ALLOWLIST_INPUT_HELPER = 'Enter the bundle ID of the apps you want to allowlist.';
export const ACCOUNT_ALLOWLIST_TOOLTIP = 'This setting keeps your Apple ID or Google account logged in on your devices.';
export const ACCOUNT_ALLOWLIST_INPUT_HELPER = 'Enter the email address of the accounts you want to allowlist.';
export const APPLE_PAY_SUPPORT_TOOLTIP = 'Sets up the device for Apple Payment testing. ';
